module.exports = __webpack_public_path__ + "media/images/category_icons/curriculum_overview-b4445cdea25189a4b091c194ce4d7d50.svg";